import { flushSync } from 'react-dom';
import {
  AgxButton,
  AgxModal,
  AgxModalTitleIcon,
  AgxSpacer,
  AgxTypography,
  Icon_AlertCircleOutline,
  type AgxDialogControlProps,
} from '@urbanx/agx.ui-components2';

export const noContractAvailableWarning = {
  title: 'No Contract Available',
  message:
    'There is no Contract available of this property. If you have been provided a Solicitor prepared Contract to upload you can continue.',
};

interface NoContractAvailableDialogProps extends AgxDialogControlProps {
  onContinue: () => Promise<void>;
}

const NoContractAvailableDialog = ({
  isOpen,
  setIsDialogOpen,
  onContinue,
}: NoContractAvailableDialogProps) => (
  <AgxModal
    id="no-contract-available-modal"
    isOpen={isOpen}
    setIsDialogOpen={setIsDialogOpen}
    title={noContractAvailableWarning.title}
    titleIcon={
      <AgxModalTitleIcon tone="warning">
        <Icon_AlertCircleOutline type="Warning" height={40} width={40} />
      </AgxModalTitleIcon>
    }
    type="single"
    maxWidth="600px"
    variant="withoutDivider"
    actionButtonContainerStyle="withDivider"
    content={
      <AgxSpacer padding={{ left: 'xl', right: 'xl', bottom: 'spacing-3xl' }}>
        <AgxTypography type="body_ui" size="small">
          {noContractAvailableWarning.message}
        </AgxTypography>
      </AgxSpacer>
    }
    actionButtons={
      <AgxSpacer direction="horizontal" gap="sm" fill>
        <AgxButton
          id="cancel-offline-contract"
          text="Cancel"
          variant="hollow"
          size="large"
          stretch
          onClick={() => setIsDialogOpen(false)}
        />
        <AgxButton
          id="continue-offline-contract"
          text="Continue"
          variant="primary"
          size="large"
          stretch
          onClick={async () => {
            flushSync(() => setIsDialogOpen(false));
            await onContinue();
          }}
        />
      </AgxSpacer>
    }
  />
);

export default NoContractAvailableDialog;
